/* Report pages use the dashboard's own card language — white surface, 1px
   border, 8px radius — so a reader moving between Availability and a report
   does not feel handed to a different product. */
.card {
  background: #fff;
  border: 1px solid var(--border-cell, #eaeaea);
  border-radius: 8px;
  padding: 16px;
}
.cardTitle {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 600;
  color: var(--header-text, #333843);
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.cardNote { font-size: 11.5px; font-weight: 400; color: var(--header-text-muted, #8f8f91); }

.basis {
  padding: 12px 14px;
  border: 1px solid #eee6c9;
  border-left: 3px solid #d8b23f;
  border-radius: 8px;
  background: #fffdf4;
  font-size: 12.5px;
  line-height: 19px;
  color: #5d5326;
}
.basis code { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 12px; }

/* KPI strip. Wraps rather than scrolls: a card pushed off-screen is a card
   nobody reads. */
.kpis { display: grid; grid-template-columns: repeat(auto-fit, minmax(168px, 1fr)); gap: 12px; }
.kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 14px;
  background: #fff;
  border: 1px solid var(--border-cell, #eaeaea);
  border-radius: 8px;
  min-width: 0;
}
.kpiLabel { font-size: 10.5px; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase; color: var(--header-text-muted, #8f8f91); }
.kpiValue { font-size: 22px; font-weight: 700; color: var(--header-text, #333843); line-height: 30px; }
.kpiValue.good { color: #1e8e4a; }
.kpiDelta { font-size: 11.5px; font-weight: 600; }
.kpiSub { font-size: 10.5px; color: var(--header-text-muted, #8f8f91); line-height: 15px; margin-top: 2px; }
.up { color: #1e8e4a; }
.down { color: #d3373c; }

.findings { list-style: none; margin: 0; padding: 0; }
.finding { padding: 12px 0; border-top: 1px solid var(--border-cell, #f0f0f0); }
.finding:first-child { border-top: 0; padding-top: 0; }
.findingText { margin: 0; font-size: 13.5px; line-height: 20px; color: var(--header-text, #333843); }
.findingBasis { margin: 4px 0 0; font-size: 11.5px; color: var(--header-text-muted, #8f8f91); }
.findingsFoot {
  margin: 10px 0 0;
  padding-top: 10px;
  border-top: 1px solid var(--border-cell, #f0f0f0);
  font-size: 11.5px;
  color: var(--header-text-muted, #8f8f91);
}

.tableWrap { overflow-x: auto; }
.table { width: 100%; border-collapse: collapse; font-size: 12.5px; }
.table th {
  text-align: left;
  padding: 8px 10px;
  background: var(--bg-table-header, #d5e6fc);
  color: var(--header-text, #333843);
  font-weight: 600;
  white-space: nowrap;
}
.table th:first-child { border-top-left-radius: 6px; }
.table th:last-child { border-top-right-radius: 6px; }
.table td { padding: 9px 10px; border-bottom: 1px solid var(--border-cell, #f0f0f0); color: var(--header-text, #333843); }
.num { text-align: right; white-space: nowrap; }
.rank { color: var(--header-text-muted, #8f8f91); }
.mine { background: #f1efff; }
.youTag {
  margin-left: 8px;
  padding: 1px 6px;
  border-radius: 9px;
  background: #5b4cf5;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
}

.skuName { display: block; max-width: 340px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.skuMeta { display: block; font-size: 11px; color: var(--header-text-muted, #8f8f91); }

.state { padding: 24px; font-size: 13px; color: var(--header-text-muted, #8f8f91); }
.error { padding: 16px; font-size: 13px; color: #b4272c; background: #fff5f5; border: 1px solid #f3d0d1; border-radius: 8px; }

/* ---- sorting and search ------------------------------------------------ */
.tools { display: flex; align-items: center; gap: 10px; margin: 0 0 10px; }
.search {
  flex: 0 1 260px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid var(--header-border, #e0e0e0);
  border-radius: 7px;
  font-size: 12.5px;
  outline: none;
}
.search:focus { border-color: #7c5cff; }
.count { font-size: 11.5px; color: var(--header-text-muted, #8f8f91); }

.sortable { cursor: pointer; user-select: none; }
.sortable:hover { background: #c9dcf6; }
.sorted { font-weight: 700; }
.caret { margin-left: 4px; font-size: 9px; opacity: 0.75; }
